export default __webpack_public_path__ + "static/media/lb-isb.00aa9d10.webp";